import _ from 'lodash';

import { Reference } from '@apollo/client';
import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';


export const Mutation: ITypeSpecificPolicy<types.Mutation> = {

  fields: {
    inviteUser: {
      merge: (existing, incoming, { args, cache }) => {
        if (!incoming) {
          existing;
        }
        if (!args?.input.id || args?.input.id === '') {
          cache.modify<types.Query>({
            fields: {
              persons: (persons, { }) => {
                return [
                  ...persons ?? [],
                  incoming
                ];
              }
            }
          });
        }
      }
    },
    inviteNonUser: {
      merge: (existing, incoming, { args, cache }) => {
        if (!incoming) {
          existing;
        }
        if (!args?.input.id || args?.input.id === '') {
          cache.modify<types.Query>({
            fields: {
              persons: (persons, { }) => {
                return [
                  ...persons ?? [],
                  incoming
                ];
              }
            }
          });
        }
      }
    },
    saveDailyReportPhoto: {
      merge: (existing, incoming, { args, cache }) => {
        if (!args?.input.id || args?.input.id === '') {
          const dailyReportId = cache.identify({
            __typename: 'DailyReport',
            __ref: `DailyReport:${args?.input.dailyReportId}`
          });
          cache.modify({
            id: dailyReportId,
            fields: {
              photos: (existing, { }) => {
                return [
                  ...existing ?? [],
                  incoming
                ];
              }
            }
          });
        }
      }
    },
    deleteDocument: {
      merge: (existing, incoming, { args, cache }) => {
        // removes on delete
        cache.evict({
          id: `Document:${args?.id}`
        });
        cache.gc();
      }
    },
    savePerson: {
      merge: (existing, incoming, { mergeObjects, cache, args }) => {

        const personId = cache.identify({
          __ref: `Person:${args?.input.id}`
        });

        if (args?.input.id && args?.input.isSuperAdmin === false) {
          cache.evict({
            id: personId
          });
          cache.gc();
          return;
        }

        return mergeObjects(existing, incoming);

      }
    },
    savePlan: {
      merge: (existing, incoming, { mergeObjects }) => {
        return mergeObjects(existing, incoming);
      }
    },
    createDocuments: {
      merge: (existing, incoming, { cache, args, toReference }) => {
        const input: types.CreateDocuments_Input = args?.input;
        if (!input) {
          return existing;
        }
        if (!incoming) {
          return existing;
        }

        const docRefs = incoming.map((node: Reference) => toReference(node, true)) ?? [];

        if (input.projectId && input.projectId !== '') {
          const projectId = cache.identify({
            __ref: `Project:${input.projectId}`
          });

          cache.modify({
            id: projectId,
            fields: {
              documents: (docs, { }) => {
                return [
                  ...docs ?? [],
                  ...docRefs
                ];
              }
            }
          });
        }

        cache.modify<types.Query>({
          fields: {
            documents: (documents, { }) => {
              return [
                ...documents ?? [],
                ...docRefs ?? []
              ];
            }
          },
          broadcast: true,
          optimistic: true
        });
        if (input.folderId && input.folderId !== '' && !_.isNull(input.folderId)) {
          const folderId = cache.identify({
            __ref: `Folder:${input.folderId}`
          });
          const docFolderRefs = incoming.map((node: Reference) => toReference(node)) ?? [];
          cache.modify({
            id: folderId,
            fields: {
              documents: (documents, { }) => {
                return [
                  ...documents ?? [],
                  ...docFolderRefs ?? []
                ];
              }
            }
          });
        }
        // }
        return [
          ...existing ?? [],
          ...incoming ?? []
        ];

      }
    },
    saveDocument: {
      merge: (existing, incoming, { cache, args, mergeObjects, toReference }) => {
        const input: types.SaveDocumentInput = args?.input;
        if (!input) {
          return existing;
        }
        if (!incoming) {
          return existing;
        }


        const docRef = toReference(incoming, true);

        if (!existing || !input.id || input.id === '') {
          cache.modify<types.Query>({
            fields: {
              documents: (documents, { }) => {
                return [
                  ...documents ?? [],
                  docRef
                ];
              }
            },
            broadcast: true,
            optimistic: true
          });
          if (incoming.folder) {
            const folderId = cache.identify(incoming.folder);
            cache.modify({
              id: folderId,
              fields: {
                documents: (documents, { }) => {
                  return [
                    ...documents ?? [],
                    toReference(incoming)
                  ];
                }
              }
            });
          }
        }
        return mergeObjects(existing, incoming);
      }
    },
    saveStandardAreaInstallation: {
      merge: (existing, incoming, { cache, args, mergeObjects, toReference }) => {
        const input: types.SaveStandardAreaInstallation_Input = args?.input;

        if (!input) {
          return existing;
        }
        if (!incoming) {
          return existing;
        }

        const standardAreaInstallationRef = toReference(incoming, true);
        if (!existing || !input.id || input.id === '') {
          cache.modify<types.Query>({
            fields: {
              standardAreaInstallations: (standardAreaInstallations, { }) => {
                return [
                  ...standardAreaInstallations ?? [],
                  standardAreaInstallationRef
                ];
              }
            },
            broadcast: true,
            optimistic: true
          });
          if (incoming.milestone) {
            const milestoneId = cache.identify(incoming.milestone);
            cache.modify({
              id: milestoneId,
              fields: {
                installations: (installations, { }) => {
                  return [
                    ...installations ?? [],
                    toReference(incoming)
                  ];
                }
              }
            });
          }

          return mergeObjects(existing, incoming);
        }
      }
    },
    removeStandardAreaInstallation: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `StandardAreaInstallation:${args?.id}`
        });
        cache.gc();
      }
    },
    removeIncident: {
      merge: (existing, incoming, { args, cache }) => {

        cache.evict({
          id: `Incident:${args?.id}`
        });
        cache.gc();
      }
    },
    removeDecision: {
      merge: (existing, incoming, { args, cache }) => {

        id: `Decision:${args?.id}`;
        cache.evict({
        });
        cache.gc();
      }
    },
    removeProject: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `Project:${args?.id}`
        });
        cache.gc();
      }
    },
    removeInstallation: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `Installation:${args?.id}`,
          broadcast: true
        });
        cache.gc();
      }
    },
    removeInstallationType: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `InstallationType:${args?.input.typeId}`,
          broadcast: true
        });
        cache.gc();
      }
    },
    removePlan: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `Plan:${args?.input.id}`
        });
        cache.gc();
      }
    },
    removePlanSet: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `PlanSet:${args?.id}`
        });
        cache.gc();
      }
    },
    removeMembership: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `Membership:${args?.id}`
        });
        cache.gc();
      }
    },
    removeInspection: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `Inspection:${args?.id}`
        });
        cache.gc();
      }
    },
    removeClientReport: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `ClientReport:${args?.id}`
        });
        cache.gc();
      }
    },
    removeClientReportLink: {
      merge: (existing, incoming, { args, cache }) => {

        cache.evict({
          id: `ClientReportLink:${args?.id}`
        });
        cache.gc();
      }
    },
    removeOnSiteWorkEvent: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `OnSiteWorkEvent:${args?.id}`
        });
        cache.gc();
      }
    },
    removeMilestone: {
      merge: (existing, incoming, { args, cache }) => {

        cache.evict({
          id: `Milestone:${args?.id}`
        });
        cache.gc();
      }
    },
    removeDelivery: {
      merge: (existing, incoming, { args, cache }) => {

        cache.evict({
          id: `MaterialDelivery:${args?.id}`
        });
        cache.gc();
      }
    },
    deleteFolder: {
      merge: (existing, incoming, { args, cache }) => {
        cache.evict({
          id: `Folder:${args?.id}`
        });
        cache.gc();
      }
    },
    duplicateFolder: {
      merge: (existing, incoming, { args, cache, toReference, mergeObjects }) => {
        const id = args?.id;
        if (!id) {
          return existing;
        }
        if (!incoming) {
          return existing;
        }
        const folderRef = toReference(incoming, true);
        if (!existing) {
          cache.modify<types.Query>({
            fields: {
              folders: (folders, { }) => {
                return [
                  ...folders ?? [],
                  folderRef
                ];
              }
            }
          });
        }
        if (existing) {
          return mergeObjects(existing, incoming);
        }
        return incoming;
      }
    },
    approveDailyReport: {
      merge: (existing, incoming, { mergeObjects }) => {
        return mergeObjects(existing, incoming);
      }
    },



    saveProject: {
      merge: (_existing, inc: Reference, { cache }) => {
        cache.modify({
          fields: {
            projects(existing) {
              if (existing.some((e: Reference) => __refsAreEqual(e, inc))) {
                return existing;
              }

              return [
                ...existing,
                inc
              ];
            }
          }
        });
      }
    }
  }
};



function __refsAreEqual(a: Reference, b: Reference) {
  return a.__ref === b.__ref;
}
